import React from "react";
import { Link } from "react-router-dom";


import saca from "./assets/saca.svg";
import tiktok from "./assets/tik-tok.png";
import whatsapp from "./assets/whatsapp.png";



const Footer: React.FC = () => {
    return (
        <>
            <div className=" bg-[#163317]">
                <footer className="flex flex-col py-16 mt-16 w-full px-4 md:px-14">
                    <div className=" w-full pb-8 border-b border-[#F3F0E94D] flex flex-col md:flex-row space-y-4 md:space-y-0 items-center justify-between">
                        <span className=" space-x-6 md:space-x-12 flex items-center">
                            <Link
                                to="/pitches"
                                className=" font-medium text-base font-Manrope text-white"
                            >
                                Pitches
                            </Link>
                            <Link
                                to="/shop"
                                className=" font-medium text-base font-Manrope text-white"
                            >
                                Shop
                            </Link>
                        </span>

                        <span className=" flex items-center space-x-6">
                            <Link to="http://wa.me/+447572672963">
                                <img src={whatsapp} alt="whatsapp" />
                            </Link>
                            <Link to="https://www.tiktok.com/@sacafootball/">
                                <img src={tiktok} alt="tiktok" />
                            </Link>
                        </span>
                    </div>
                    <div className=" pt-8 w-full flex flex-col md:flex-row items-center justify-center md:justify-between space-y-6 md:space-y-0">
                        <p className="font-normal text-base font-Manrope text-white">
                            © 2024 SACA. All Rights Reserved.
                        </p>
                        <span className=" space-x-6 md:space-x-12 flex items-center">
                            <Link
                                to="/privacy"
                                className=" font-medium text-base font-Manrope text-white"
                            >
                                Privacy Policy
                            </Link>
                            <Link
                                to="/terms"
                                className=" font-medium text-base font-Manrope text-white"
                            >
                                Terms & Conditions
                            </Link>
                        </span>
                    </div>
                </footer>

                <img src={saca} className=" w-full" alt="" />
            </div>
        </>
    );
};

export default Footer;
